export const DialogService = Symbol('DialogService');
